import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as filters from 'utils/filters';
import 'babel-polyfill'; // 兼容IE11
import 'url-search-params-polyfill'; // 兼容IE11
import 'utils/storage';
import 'assets/common.less';
import vConsole from 'vconsole';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {success,error,error_text} from '@/request/commom.js'
import {get,post} from '@/request/http.js'
import {path} from '@/request/path.js'
import * as echarts from 'echarts'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
// Vue.use(Element);
Vue.use(Element, { size: 'small', zIndex: 3000 });
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment;
Vue.prototype.$success = success;
Vue.prototype.$error = error;
Vue.prototype.$error_text = error_text;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$path = path;
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
